import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../Pages/Login";
import "./../Styles/worklist.css";
import Profile from "../Pages/Profie";
import { API } from "../../config/api";
export default function WorkList() {
  const BASE_URL = `${API.BASE_URL}/api.php`;
  const UPLOAD_URL = `${API.BASE_URL}/uploads/work`;
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [commission, setCommission] = useState(0);
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedWork, setSelectedWork] = useState(null);
  const [priceInput, setPriceInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [lightboxData, setLightboxData] = useState(null);
  const DESIGN_TYPES = ["Multi", "Sequence", "Cording", "Beads"];

  const getDescriptionData = (description = "") => {
    const selectedTypes = [];
    let remainingDescription = description;

    DESIGN_TYPES.forEach((type) => {
      const regex = new RegExp(`(^|,|\\n)\\s*${type}\\s*(?=,|\\n|$)`, "gi");

      if (regex.test(description)) {
        selectedTypes.push(type);
      }

      // Reset regex and remove only selected design types
      remainingDescription = remainingDescription.replace(regex, "$1");
    });

    remainingDescription = remainingDescription
      .replace(/,\s*,/g, ",")
      .replace(/^\s*,\s*/g, "")
      .replace(/\s*,\s*$/g, "")
      .replace(/^\s*\n/gm, "")
      .replace(/\n{2,}/g, "\n")
      .trim();

    return {
      designTypes: selectedTypes,
      customDescription: remainingDescription,
    };
  };
  const openDescriptionModal = (description) => {
    setSelectedDescription(description);
    setShowDescriptionModal(true);
  };
  const getCommission = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_platform_bid_commission`,
      );

      const result = await response.json();

      if (result.status) {
        setCommission(Number(result.commission));
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getWorks();
    getCommission();
  }, []);

  const getWorks = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}?action=get_all_works_Active`);
      const result = await response.json();

      if (result.status) {
        setWorks(result.data);
      }
    } catch (err) {
      console.error("Error fetching works:", err);
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // LIGHTBOX CONTROLS
  // ==========================
  const openLightbox = (imagesArray, initialIndex, ownerId) => {
    const fullUrls = imagesArray.map(
      (img) => `${UPLOAD_URL}/${ownerId}/${img}`,
    );
    setLightboxData({
      images: fullUrls,
      currentIndex: initialIndex,
    });
  };

  const handlePrevImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.images.length - 1
          : prev.currentIndex - 1,
    }));
  }, [lightboxData]);

  const handleNextImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.images.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  }, [lightboxData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxData) return;
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "Escape") setLightboxData(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxData, handlePrevImage, handleNextImage]);

  const handleOpenAddBeads = (work) => {
    if (!user) {
      alert("Please login first.");
      setShowLogin(true);
      return;
    }

    const providerOptions = user.provider_options || "";

    const isDesigner = Array.isArray(providerOptions)
      ? providerOptions.some((item) => item.toLowerCase() === "designers")
      : providerOptions
          .toLowerCase()
          .split(",")
          .map((v) => v.trim())
          .includes("designers");

    if (!isDesigner) {
      alert(
        "Only Designer accounts can add bids.\n\nPlease update your profile and enable the Designer option.",
      );

      setShowProfile(true);

      return;
    }

    setSelectedWork(work);
    setPriceInput("");
  };

  const handleConfirmAddBeads = async (e) => {
    e.preventDefault();

    if (!priceInput.trim() || isNaN(priceInput) || Number(priceInput) <= 0) {
      alert("Please enter a valid positive price.");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("work_id", selectedWork.id);
    formData.append("price", priceInput);

    try {
      const response = await fetch(`${BASE_URL}?action=add_beads_from_work`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        setSelectedWork(null);

        const userTab = window.open("", "EmbroideryUser");

        userTab.location.href = `${window.location.origin}/user/myBids`;
        userTab.focus();
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const bidPrice = Number(priceInput || 0);

  const commissionAmount = (bidPrice * commission) / 100;

  const finalAmount = bidPrice - commissionAmount;

  const openWorkDetails = (work) => {
    navigate("/work-details", {
      state: {
        work,
      },
    });
  };

  return (
    <div className="eb-worklist-container">
      {/* Header Banner */}
      <div className="eb-worklist-header">
        <div>
          <h2 className="eb-header-title">Available Works</h2>
        </div>
        <div className="eb-header-badge">
          <span>{works.length}</span> Active Items
        </div>
      </div>

      {/* Grid Content */}
      {loading ? (
        <div className="eb-loading-box">
          <div className="eb-spinner"></div>
          <p>Loading available works...</p>
        </div>
      ) : works.length > 0 ? (
        <div className="eb-works-grid">
          {works.map((item) => (
            <div
              className="eb-work-card"
              key={item.id}
              onClick={() => openWorkDetails(item)}
              style={{ cursor: "pointer" }}
            >
              <div className="eb-card-media">
                {item.images && item.images.length > 0 ? (
                  <div
                    className="eb-work-image-preview"
                    onClick={(e) => {
                      e.stopPropagation();
                      openWorkDetails(item);
                    }}
                  >
                    {/* FIRST IMAGE */}
                    <img
                      src={`${UPLOAD_URL}/${item.owner_id}/${item.images[0]}`}
                      className="eb-card-img"
                      alt={`Work ${item.id} preview`}
                    />

                    {/* MULTIPLE IMAGE COUNT */}
                    {item.images.length > 1 && (
                      <div className="eb-image-count-overlay">
                        <i className="bi bi-images"></i>
                        <span>+{item.images.length}</span>
                      </div>
                    )}

                    {/* VIEW OVERLAY */}
                  </div>
                ) : (
                  <div className="eb-no-image">
                    <i className="bi bi-image"></i>
                    <span>No image available</span>
                  </div>
                )}
              </div>

              {/* Card Body */}
              <div className="eb-card-body">
                <div className="eb-card-date">
                  <i className="bi bi-calendar-event me-2"></i>
                  {item.created_at
                    ? new Date(item.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "-"}
                </div>

                {/* <div
                  className="eb-work-details-btn mb-2"
                  onClick={() =>
                    openDescriptionModal(
                      item.description || "No description provided.",
                    )
                  }
                >
                  <i className="bi bi-journal-text pe-2"></i>
                  <span className="fs-6">Work Details</span>
                  <i className="bi bi-chevron-right ms-auto"></i>
                </div> */}
                {/* <div className="eb-work-specs1">
                  <div className="eb-work-spec-card">
                    <small>Height:</small>
                    <strong>{item.height || "-"}</strong>
                  </div>

                  <div className="eb-work-spec-card">
                    <small>Area:</small>
                    <strong>{item.area || "-"}</strong>
                  </div>

                  <div className="eb-work-spec-card">
                    <small>Color:</small>
                    <strong>{item.color || "-"}</strong>
                  </div>
                </div> */}
                {(() => {
                  const { designTypes, customDescription } = getDescriptionData(
                    item.description || "",
                  );

                  return (
                    <div
                      className="eb-work-description-section"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDescriptionModal(item.description);
                      }}
                    >
                      {/* SHOW ONLY SELECTED DESIGN TYPES */}
                      {designTypes.length > 0 && (
                        <div className="eb-design-type-list">
                          {designTypes.map((type) => (
                            <span
                              key={type}
                              className={`eb-design-type-badge eb-design-type-${type
                                .toLowerCase()
                                .replace(/\s/g, "")}`}
                            >
                              <i className="bi bi-check-circle-fill"></i>
                              {type}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* SHOW CUSTOM DESCRIPTION SEPARATELY */}
                      {/* {customDescription && (
                        <p className="eb-info-desc eb-desc-click">
                          {customDescription.length > 120
                            ? customDescription.substring(0, 120) + "..."
                            : customDescription}
                        </p>
                      )}

                      {!customDescription && designTypes.length === 0 && (
                        <p className="eb-info-desc">No description provided.</p>
                      )} */}
                    </div>
                  );
                })()}
                <div className="eb-work-card-actions mt-2">
                  <button
                    type="button"
                    className="eb-work-card-add-bid"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenAddBeads(item);
                    }}
                  >
                    <i className="bi bi-plus-circle-fill"></i>
                    <span>Add Bids</span>
                  </button>
                  <button
                    type="button"
                    className="eb-work-card-view-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      openWorkDetails(item);
                    }}
                    title="View Work"
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="eb-empty-state">
          <div className="eb-empty-icon">
            <i className="bi bi-inbox"></i>
          </div>
          <h4>No Active Work Available</h4>
          <p>
            There are currently no active work requests listed. Check back
            later!
          </p>
        </div>
      )}

      {/* Modal for Pricing Input */}
      {selectedWork && (
        <div
          className="eb-modal-backdrop"
          onClick={() => setSelectedWork(null)}
        >
          <div className="eb-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="eb-modal-header">
              <h5>Add Bids Option</h5>
              <button
                className="eb-modal-close-btn"
                onClick={() => setSelectedWork(null)}
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleConfirmAddBeads}>
              <div className="eb-modal-body">
                <p className="eb-modal-desc">
                  Specify your quote for this work request.
                </p>

                <div className="eb-input-group">
                  <label>Bid Price (₹)</label>

                  <input
                    type="number"
                    min="1"
                    step="any"
                    placeholder="Enter your bid"
                    value={priceInput}
                    onChange={(e) => setPriceInput(e.target.value)}
                    required
                  />
                </div>

                <div
                  style={{
                    marginTop: 20,
                    background: "#f8f9fa",
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: 15,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    <span>Your Bid</span>
                    <strong>₹ {bidPrice.toFixed(2)}</strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                      color: "#dc3545",
                    }}
                  >
                    <span>Platform Commission ({commission}%)</span>
                    <strong>- ₹ {commissionAmount.toFixed(2)}</strong>
                  </div>

                  <hr />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 18,
                    }}
                  >
                    <span>You Will Receive</span>
                    <strong style={{ color: "#198754" }}>
                      ₹ {finalAmount.toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
              <div className="eb-modal-footer">
                <button
                  type="button"
                  className="eb-btn-secondary"
                  onClick={() => setSelectedWork(null)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="eb-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Confirm & Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Full Screen Image Lightbox Modal with Slider */}
      {lightboxData && (
        <div
          className="eb-image-modal-backdrop"
          onClick={() => setLightboxData(null)}
        >
          <div
            className="eb-image-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              type="button"
              className="eb-image-modal-close"
              onClick={() => setLightboxData(null)}
              title="Close (Esc)"
            >
              &times;
            </button>

            {/* Slider Image */}
            <img
              src={lightboxData.images[lightboxData.currentIndex]}
              alt={`Expanded Preview ${lightboxData.currentIndex + 1}`}
              className="eb-image-modal-src"
            />

            {/* Previous & Next Navigation Buttons */}
            {lightboxData.images.length > 1 && (
              <>
                <button
                  type="button"
                  className="eb-lightbox-nav eb-lightbox-prev"
                  onClick={handlePrevImage}
                  title="Previous Image (Left Arrow)"
                >
                  <i className="bi bi-chevron-left"></i>
                </button>

                <button
                  type="button"
                  className="eb-lightbox-nav eb-lightbox-next"
                  onClick={handleNextImage}
                  title="Next Image (Right Arrow)"
                >
                  <i className="bi bi-chevron-right"></i>
                </button>

                {/* Counter Tag */}
                <div className="eb-lightbox-counter">
                  {lightboxData.currentIndex + 1} / {lightboxData.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {showProfile && (
        <Profile isOpen={showProfile} onClose={() => setShowProfile(false)} />
      )}
      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);

          navigate("/register", {
            state: { from: "/Work-list" },
          });
        }}
      />
      {showDescriptionModal && (
        <div
          className="eb-modal-backdrop"
          onClick={() => setShowDescriptionModal(false)}
        >
          <div
            className="eb-modal-card"
            style={{ maxWidth: "700px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="eb-modal-header">
              <h5>Work Description</h5>

              <button
                className="eb-modal-close-btn"
                onClick={() => setShowDescriptionModal(false)}
              >
                &times;
              </button>
            </div>

            <div className="eb-modal-body">
              <p
                style={{
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.8",
                  fontSize: "15px",
                }}
              >
                {selectedDescription}
              </p>
            </div>

            <div className="eb-modal-footer">
              <button
                className="eb-btn-secondary"
                onClick={() => setShowDescriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
